// ─────────────────────────────────────────────────────────────
//  ORGANISATION — VARIABLE UNIQUE DE LA DÉMONSTRATION
//
//  Pour rebrander la démo au nom d'un prospect, modifier
//  UNIQUEMENT ce bloc. Aucun nom d'organisation ne doit être
//  écrit en dur ailleurs dans le code.
//
//  ⚠️  Les données de talents, scores et résultats sont fictives.
//      Le bandeau de démonstration (isDemo) doit rester visible.
// ─────────────────────────────────────────────────────────────

export type Org = {
  name: string
  shortName: string
  initials: string
  industry: string
  headcount: string
  city: string
  /** true = cabinet/agence recrutant pour plusieurs organisations.
   *  false = entreprise recrutant pour elle-même (cadrage cible). */
  agencyMode: boolean
  /** Affiche le bandeau « données fictives ». À laisser à true. */
  isDemo: boolean
  atsName: string
}

export const org: Org = {
  name: 'Groupe Meridia',
  shortName: 'Meridia',
  initials: 'GM',
  industry: 'Services financiers',
  headcount: '4 200 employés',
  city: 'Montréal',
  agencyMode: false,
  isDemo: true,
  atsName: 'Workday',
}

export const currentUser = {
  name: 'Vivianne Tremblay',
  initials: 'VT',
  role: 'Directrice, acquisition de talents',
}
